import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../../core/entities';

interface DataRecoveredPassword {
  email: string;
  password: string;
}

interface AuthState {
  status: 'checking' | 'authenticated' | 'not-authenticated';
  user: User | null;
  errorMessage?: string;
  dataToRecoverPassword: DataRecoveredPassword;
}

const initialState: AuthState = {
  status: 'checking',
  user: null,
  errorMessage: undefined,
  dataToRecoverPassword: {
    email: '',
    password: '',
  },
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    onChecking: (state) => {
      state.status = 'checking';
      state.user = null;
      state.errorMessage = undefined;
    },
    onLogin: (state, action: PayloadAction<User>) => {
      state.status = 'authenticated';
      state.user = action.payload;
      state.errorMessage = undefined;
    },
    onLogout: (state, action: PayloadAction<string | undefined>) => {
      state.status = 'not-authenticated';
      state.user = null;
      state.errorMessage = action.payload;
    },
    clearErrorMessage: (state) => {
      state.errorMessage = undefined;
    },
    setDataToRecoverPassword: (
      state,
      action: PayloadAction<DataRecoveredPassword>
    ) => {
      state.dataToRecoverPassword = action.payload;
    },
  },
});

export const {
  onChecking,
  onLogin,
  onLogout,
  clearErrorMessage,
  setDataToRecoverPassword,
} = authSlice.actions;
